import React, { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { MainArticleLayout } from '../../layouts/MainArticleLayout'
import ErrorFallback from '../common/ErrorFallback'
import { FormDependencyLoaderProvider } from '../context/FormDependencyLoaderContext'
import UnpaidWagesBreadcrumbs from './UnpaidWagesBreadcrumbs'
import UnpaidWagesMain from './UnpaidWagesMain'

const UnpaidWagesLanding = () => {
  return (
    <Suspense fallback={null}>
      <FormDependencyLoaderProvider>
        <MainArticleLayout>
          <UnpaidWagesBreadcrumbs />
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <UnpaidWagesMain />
          </ErrorBoundary>
        </MainArticleLayout>
      </FormDependencyLoaderProvider>
    </Suspense>
  )
}

export default UnpaidWagesLanding
